import { render, staticRenderFns } from "./SuppliesItemsModal.vue?vue&type=template&id=ee8c1660&scoped=true"
import script from "./SuppliesItemsModal.vue?vue&type=script&lang=js"
export * from "./SuppliesItemsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8c1660",
  null
  
)

export default component.exports